/**
 * Pendant chain chips — Metal / Color / Length over Thinkspace chain selects.
 *
 * Same chip language as Metal Type / Stone Type. Color uses the metal swatches.
 * Length shows Thinkspace's combination price when the option label has +$.
 *
 * Depends on: sj-3d-builder.js, sj-metal-chips.css
 */
(function () {
  'use strict';

  var B = window.Sj3dBuilder;
  if (!B) return;

  var READY = 'data-sj-chain-chips-ready';
  var OPTIONS = ['Chain Metal', 'Chain Color', 'Chain Length'];

  var METAL_COPY = {
    'Stainless Steel': { title: 'Stainless Steel', subtitle: 'Everyday Wear' },
    '14K Gold': { title: '14K Gold', subtitle: 'Rich & Luxurious' },
  };

  function metalCopy(value, text) {
    var raw = String(value || '').trim();
    var label = String(text || '').trim();
    if (METAL_COPY[raw]) return METAL_COPY[raw];
    if (/stainless/i.test(raw) || /stainless/i.test(label)) {
      return METAL_COPY['Stainless Steel'];
    }
    if (/14\s*k/i.test(raw) || /14\s*k/i.test(label)) {
      return METAL_COPY['14K Gold'];
    }
    return {
      title: raw || label || 'Metal',
      subtitle: label && label !== raw ? label.replace(/\s*\+.*$/, '').trim() : '',
    };
  }

  function colorKey(value, label) {
    var v = String(value || '').toLowerCase();
    var t = String(label || '').trim();
    if (v === 'yellow' || /yellow/i.test(t)) return 'yellow';
    if (v === 'rose' || /rose/i.test(t)) return 'rose';
    if (v === 'white' || /white/i.test(t)) return 'white';
    if (v === 'silver' || /silver/i.test(t)) return 'pl-silver';
    return v || '';
  }

  function colorTitle(value, label) {
    var key = colorKey(value, label);
    if (key === 'yellow') return 'Yellow';
    if (key === 'white') return 'White';
    if (key === 'rose') return 'Rose';
    if (key === 'pl-silver') return 'Silver';
    return String(label || value || 'Color').replace(/\s*\+.*$/, '').trim();
  }

  function lengthCopy(value, text) {
    var raw = String(value || '').trim();
    var label = String(text || '').replace(/\s+/g, ' ').trim();
    var inches = raw.replace(/["”]/g, '');
    var title = inches ? inches + '"' : label.replace(/\s*\+.*$/, '').trim() || raw;
    var price = '';
    var m = label.match(/\+\s*\$?\s*([\d,]+(?:\.\d{2})?)/);
    if (m) {
      var n = Number(String(m[1]).replace(/,/g, ''));
      if (Number.isFinite(n) && n > 0) {
        price = '+$' + (n % 1 === 0 ? String(Math.round(n)) : n.toFixed(2));
      }
    }
    return { title: title, subtitle: price };
  }

  function swatchMap() {
    var m = B.stepperConfig && B.stepperConfig().metalSwatches;
    return m && typeof m === 'object' ? m : {};
  }

  function optionListSignature(items) {
    var parts = [];
    for (var i = 0; i < items.length; i++) {
      parts.push(
        String(items[i].value || '') + ':' + (items[i].disabled ? '1' : '0')
      );
    }
    return parts.join('|');
  }

  function ensureMount(field) {
    var mount = field.querySelector('[data-sj-chain-chips]');
    if (!mount) {
      mount = document.createElement('div');
      mount.setAttribute('data-sj-chain-chips', '');
      field.appendChild(mount);
    }
    return mount;
  }

  function fieldKind(field) {
    var name = field.getAttribute('data-option') || '';
    if (name === 'Chain Metal') return 'metal';
    if (name === 'Chain Color') return 'color';
    if (name === 'Chain Length') return 'length';
    return '';
  }

  function copyFor(kind, value, text) {
    if (kind === 'metal') return metalCopy(value, text);
    if (kind === 'length') return lengthCopy(value, text);
    return { title: colorTitle(value, text), subtitle: '' };
  }

  function renderChips(field) {
    var select = field.querySelector('select');
    if (!select) return;
    var kind = fieldKind(field);
    if (!kind) return;

    var mount = ensureMount(field);
    var current = String(select.value || '');
    var opts = Array.from(select.options || []).filter(function (opt) {
      return !opt.disabled && String(opt.value || '').trim() !== '';
    });
    if (!opts.length) return;

    var title = field.getAttribute('data-option') || 'Chain';
    var selectedCopy = null;
    for (var s = 0; s < opts.length; s++) {
      if (String(opts[s].value).trim() === current) {
        selectedCopy = copyFor(kind, opts[s].value, opts[s].textContent);
        break;
      }
    }

    var wrap = document.createElement('div');
    wrap.className =
      'sj-option-chips sj-chain-chips sj-chain-chips--' +
      kind +
      (kind === 'color' ? ' sj-color-chips sj-color-chips--swatches' : '');
    wrap.setAttribute('data-sj-sig', optionListSignature(opts));
    wrap.setAttribute('role', 'group');
    wrap.setAttribute('aria-label', title);

    var root = wrap;
    if (kind === 'color') {
      var panel = document.createElement('div');
      panel.className = 'sj-color-panel sj-color-panel--pendant sj-color-panel--compact';
      panel.setAttribute('role', 'group');
      panel.setAttribute('aria-label', title);
      var head = document.createElement('div');
      head.className = 'sj-color-panel__head';
      head.innerHTML =
        '<span class="sj-color-panel__title">' +
        title +
        (selectedCopy ? ':' : '') +
        '</span>' +
        (selectedCopy
          ? '<span class="sj-color-panel__summary">' + selectedCopy.title + '</span>'
          : '');
      panel.appendChild(head);
      panel.appendChild(wrap);
      root = panel;
    }

    var map = swatchMap();

    opts.forEach(function (opt) {
      var value = String(opt.value).trim();
      var copy = copyFor(kind, value, opt.textContent);
      var on = value === current;
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className =
        'sj-option-chip' +
        (kind === 'color' ? ' sj-option-chip--color sj-option-chip--swatch-only' : '');
      if (kind === 'metal' && /14\s*k/i.test(value + ' ' + copy.title)) {
        btn.classList.add('sj-option-chip--14k');
      }
      if (kind === 'color' && colorKey(value, opt.textContent) === 'white') {
        btn.classList.add('sj-option-chip--white-gold');
      }
      if (kind === 'color' && colorKey(value, opt.textContent) === 'pl-silver') {
        btn.classList.add('sj-option-chip--pl-silver');
      }
      btn.classList.toggle('is-selected', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      btn.setAttribute(
        'aria-label',
        copy.subtitle ? copy.title + ', ' + copy.subtitle : copy.title
      );

      if (kind === 'color') {
        var key = colorKey(value, opt.textContent);
        var imgUrl = (key && map[key]) || map.white || '';
        if (imgUrl) {
          btn.innerHTML =
            '<img class="sj-option-chip__swatch-img" src="' +
            imgUrl +
            '" alt="" width="40" height="40" loading="lazy" decoding="async">';
        } else {
          btn.innerHTML =
            '<span class="sj-option-chip__swatch" style="background-color:#ccc"></span>';
        }
      } else {
        btn.innerHTML =
          '<span class="sj-option-chip__text">' +
          '<span class="sj-option-chip__title">' +
          copy.title +
          '</span>' +
          (copy.subtitle
            ? '<span class="sj-option-chip__subtitle">' + copy.subtitle + '</span>'
            : '') +
          '</span>';
      }

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        B.setSelectValue(select, value);
        window.setTimeout(function () {
          OPTIONS.forEach(function (name) {
            var other = document.querySelector(
              '[data-option="' + name + '"].sj-chain-chips-host'
            );
            if (other) refreshChips(other, true);
          });
        }, 0);
      });
      wrap.appendChild(btn);
    });

    mount.innerHTML = '';
    mount.appendChild(root);
    field.classList.add('sj-chain-chips-host', 'sj-chain-chips-host--' + kind);
  }

  function refreshChips(field, force) {
    var select = field.querySelector('select');
    if (!select) return;
    var opts = Array.from(select.options || []).filter(function (opt) {
      return !opt.disabled && String(opt.value || '').trim() !== '';
    });
    var mount = field.querySelector('[data-sj-chain-chips]');
    var wrap = mount && mount.querySelector('.sj-chain-chips');
    var buttons = wrap && wrap.querySelectorAll('.sj-option-chip');
    var sig = optionListSignature(opts);
    if (
      !force &&
      wrap &&
      buttons &&
      wrap.getAttribute('data-sj-sig') === sig &&
      buttons.length === opts.length
    ) {
      var current = String(select.value || '');
      for (var i = 0; i < buttons.length; i++) {
        var on = String(opts[i].value).trim() === current;
        buttons[i].classList.toggle('is-selected', on);
        buttons[i].setAttribute('aria-pressed', on ? 'true' : 'false');
      }
      return;
    }
    renderChips(field);
  }

  function enhanceField(field) {
    if (!field || field.getAttribute(READY) === '1') return;
    var select = field.querySelector('select');
    if (!select) return;

    field.setAttribute(READY, '1');
    renderChips(field);

    var refresh = B.rafDebounce
      ? B.rafDebounce(function () {
          refreshChips(field);
        })
      : function () {
          refreshChips(field);
        };
    var mo = new MutationObserver(refresh);
    mo.observe(select, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['value', 'selected', 'disabled'],
    });
    select.addEventListener('change', refresh);
    field._sjChainMo = mo;
  }

  function scan() {
    OPTIONS.forEach(function (name) {
      document
        .querySelectorAll('[data-option="' + name + '"]')
        .forEach(enhanceField);
    });
  }

  B.bootOnWidget(function (widget) {
    B.watchWidget(widget, scan);
  });
})();
